import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Our own Tailwind names (theme.css). tailwind-merge must know them: without this it would read
 * `text-stat` as a colour and drop it next to `text-success`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['label', 'body', 'logo', 'stat', 'title'],
      radius: ['control', 'card'],
      shadow: ['card'],
    },
  },
});

/**
 * Joins class names and lets a later Tailwind class win over an earlier one of the same kind:
 * `cn('px-4 text-ink', 'text-white')` → `px-4 text-white`. Components use it to accept a `className`.
 */
export function cn(...classes: ClassValue[]): string {
  return twMerge(clsx(classes));
}
